
$(document).ready(function () {

    $('#openSearch').click(function (e) {
        e.preventDefault();
        let _searchPopUp = $('#searchPopUp');
        if (_searchPopUp.length) {
            _searchPopUp.addClass('is-active');
            // _searchPopUp.css({
            //     'transform': 'translateY(0%)'
            // });
        }
        $('body').css('overflow', 'hidden');
    });

    $('#closeSearch').click(function (e) {
        e.preventDefault();
        let _searchPopUp = $('#searchPopUp');
        if (_searchPopUp.length) {
            _searchPopUp.removeClass('is-active');
            // _searchPopUp.css({
            //     'transform': 'translateY(-100%)'
            // });

        }
        $('body').css('overflow', 'visible');
    });


    const wrapper = $('#content-wrapper');
    const header = $('header');
    const footer = $('footer');
    const height = $(window).height() - header.height() - footer.height() - parseFloat(footer.css('marginTop'));
    wrapper.css('minHeight', height);
});
